// screens/customers/[id]/CustomerDetail.js
import React, { useEffect, useState } from 'react';
import { useParams, Link, Outlet, useLocation } from 'react-router-dom';
import {
  FiInfo, FiShoppingCart, FiMapPin,
  FiFileText, FiDollarSign, FiBarChart2
} from 'react-icons/fi';
import { getCustomerById } from '../customerService';

const tabs = [
  { label: 'Info', path: 'info', icon: <FiInfo /> },
  { label: 'Order Placed', path: 'orders', icon: <FiShoppingCart /> },
  { label: 'Visits', path: 'visits', icon: <FiMapPin /> },
  { label: 'Statement', path: 'statement', icon: <FiDollarSign /> },
  { label: 'Invoices', path: 'invoice', icon: <FiFileText /> },
  { label: 'Credit Notes', path: 'credit-notes', icon: <FiFileText /> },
  { label: 'Stats', path: 'stats', icon: <FiBarChart2 /> },
  { label: 'Products', path: 'products', icon: <FiBarChart2 /> },
];

export default function CustomerDetail() {
  const { id } = useParams();
  const location = useLocation();
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    async function fetchCustomer() {
      const data = await getCustomerById(id);
      setCustomer(data);
    }
    fetchCustomer();
  }, [id]);

  const isActive = (path) =>
    location.pathname.endsWith(path) || location.pathname.includes(`/${path}`);

  return (
    <div className="p-4 md:p-6">
      <h1 className="text-xl md:text-2xl font-bold mb-4">
        {customer?.name || 'Customer Detail'}
      </h1>

      {/* Tabs */}
      <div className="overflow-x-auto mb-6">
        <div className="flex gap-2 md:gap-3 whitespace-nowrap">
          {tabs.map(tab => (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex items-center gap-2 px-4 py-2 text-sm md:text-base rounded-full transition font-medium ${
                isActive(tab.path)
                  ? 'bg-blue-700 text-white shadow'
                  : 'bg-gray-200 text-gray-700 hover:bg-blue-100'
              }`}
            >
              <span className="text-base">{tab.icon}</span>
              <span>{tab.label}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-lg shadow p-4 md:p-6">
        <Outlet context={{ customer }} />
      </div>
    </div>
  );
}
